<div class="dashboardPage" *ngIf="site?.name === 'ARL Hoteo'">
  <app-widget-maramataka-phase></app-widget-maramataka-phase>
  <app-weather-forecast-chart class="hide-check"></app-weather-forecast-chart>
  <app-wind-barb-chart
    [config]="ChartConfig.WeatherWM"
    targetSiteName="ARL Hoteo"
    [enableExpansion]="true"
    class="hide-check"
  ></app-wind-barb-chart>
  <app-basic-polar-bar-chart
    [config]="ChartConfig.WindWM"
    [ranges]="ChartConfig.WindSpeedRangesWM"
    targetSiteName="ARL Hoteo"
    [enableExpansion]="true"
    class="hide-check"
  ></app-basic-polar-bar-chart>
  <app-aggregate-cartesian-chart
    [config]="ChartConfig.Lizard2023SurveyResults"
    startDateOverride="2023-01-01"
    endDateOverride="2023-12-31"
    targetSiteName="ARL Hoteo"
    [enableExpansion]="true"
    class="hide-check"
  ></app-aggregate-cartesian-chart>
  <app-aggregate-cartesian-chart
    [config]="ChartConfig.HochstettersFrog"
    startDateOverride="2023-01-01"
    endDateOverride="2023-12-31"
    targetSiteName="ARL Hoteo"
    [enableExpansion]="true"
    class="hide-check"
  ></app-aggregate-cartesian-chart>
  <app-aggregate-cartesian-chart
    [config]="ChartConfig.WetlandBirds"
    startDateOverride="2023-01-01"
    endDateOverride="2023-12-31"
    targetSiteName="ARL Hoteo"
    [enableExpansion]="true"
    class="hide-check"
  ></app-aggregate-cartesian-chart>
  <app-basic-bar-chart
    [config]="ChartConfig.MacroinvertebrateCommunityIndexSoftBottomStreams"
    targetSiteName="ARL Hoteo"
    [enableExpansion]="true"
    class="hide-check"
  ></app-basic-bar-chart>
  <app-basic-bar-chart
    [config]="ChartConfig.MacroinvertebrateCommunityIndexHardBottomStreams"
    targetSiteName="ARL Hoteo"
    [enableExpansion]="true"
    class="hide-check"
  ></app-basic-bar-chart>
  <app-basic-cartesian-chart
    [config]="ChartConfig.PeriphytonClean"
    targetSiteName="ARL Hoteo"
    [enableExpansion]="true"
    class="hide-check"
  ></app-basic-cartesian-chart>
  <app-basic-bar-chart
    [config]="ChartConfig.PeriphytonCoverCompositionEc1"
    targetSiteName="ARL Hoteo"
    [enableExpansion]="true"
    class="hide-check"
  ></app-basic-bar-chart>
  <app-basic-bar-chart
    [config]="ChartConfig.PeriphytonCoverCompositionEc2"
    targetSiteName="ARL Hoteo"
    [enableExpansion]="true"
    class="hide-check"
  ></app-basic-bar-chart>
  <app-basic-bar-chart
    [config]="ChartConfig.PeriphytonCoverCompositionEc4"
    targetSiteName="ARL Hoteo"
    [enableExpansion]="true"
    class="hide-check"
  ></app-basic-bar-chart>
  <app-basic-bar-chart
    [config]="ChartConfig.WetlandsSediment"
    targetSiteName="ARL Hoteo"
    [enableExpansion]="true"
    class="hide-check"
  ></app-basic-bar-chart>
  <!-- <app-macrophytes-pie-chart
    [config]="ChartConfig.WetlandsVegetationSpeciesComposition"
    targetSiteName="ARL Hoteo"
    [enableExpansion]="true"
    class="hide-check"
  ></app-macrophytes-pie-chart> -->
  <app-aggregate-cartesian-chart
    [config]="ChartConfig.WetlandsVegetationSpeciesRichness"
    startDateOverride="2023-01-01"
    endDateOverride="2023-12-31"
    targetSiteName="ARL Hoteo"
    [enableExpansion]="true"
    class="hide-check"
  ></app-aggregate-cartesian-chart>
  <app-aggregate-cartesian-chart
    [config]="ChartConfig.TerrestrialVegetationComposition"
    startDateOverride="2023-01-01"
    endDateOverride="2023-12-31"
    [doubleWidth]="true"
    targetSiteName="ARL Hoteo"
    [enableExpansion]="true"
    class="hide-check"
  ></app-aggregate-cartesian-chart>
  <app-aggregate-cartesian-chart
    [config]="ChartConfig.TerrestrialBirdSpeciesCounts"
    startDateOverride="2023-01-01"
    endDateOverride="2023-12-31"
    [doubleWidth]="true"
    targetSiteName="ARL Hoteo"
    [enableExpansion]="true"
    class="hide-check"
  ></app-aggregate-cartesian-chart>
  <app-macrophytes-pie-chart
    [config]="ChartConfig.Macrophytes"
    targetSiteName="ARL Hoteo"
    [enableExpansion]="true"
    class="hide-check"
  ></app-macrophytes-pie-chart>
  <app-macrophytes-bar-chart
    [config]="ChartConfig.MacrophytesBT"
    targetSiteName="ARL Hoteo"
    [enableExpansion]="true"
    class="hide-check"
  ></app-macrophytes-bar-chart>
  <app-basic-cartesian-chart
    [config]="ChartConfig.ARLGroundWaterLevels"
    targetSiteName="ARL Hoteo"
    [enableExpansion]="true"
    class="hide-check"
  ></app-basic-cartesian-chart>
  <app-basic-bar-chart
    [config]="ChartConfig.ARLStreamFlow"
    targetSiteName="ARL Hoteo"
    [enableExpansion]="true"
    class="hide-check"
  ></app-basic-bar-chart>
  <app-basic-cartesian-chart
    [config]="ChartConfig.SurfacewaterSW1A"
    targetSiteName="ARL Hoteo"
    [enableExpansion]="true"
    class="hide-check"
  ></app-basic-cartesian-chart>
  <app-basic-cartesian-chart
    [config]="ChartConfig.SurfacewaterSW2A"
    targetSiteName="ARL Hoteo"
    [enableExpansion]="true"
    class="hide-check"
  ></app-basic-cartesian-chart>
  <app-basic-cartesian-chart
    [config]="ChartConfig.SurfacewaterSW3A"
    targetSiteName="ARL Hoteo"
    [enableExpansion]="true"
    class="hide-check"
  ></app-basic-cartesian-chart>
  <app-basic-cartesian-chart
    [config]="ChartConfig.SurfacewaterSW4A"
    targetSiteName="ARL Hoteo"
    [enableExpansion]="true"
    class="hide-check"
  ></app-basic-cartesian-chart>
  <app-basic-cartesian-chart
    [config]="ChartConfig.SurfacewaterSW5A"
    targetSiteName="ARL Hoteo"
    [enableExpansion]="true"
    class="hide-check"
  ></app-basic-cartesian-chart>
  <app-basic-cartesian-chart
    [config]="ChartConfig.SurfacewaterH10"
    targetSiteName="ARL Hoteo"
    [enableExpansion]="true"
    class="hide-check"
  ></app-basic-cartesian-chart>
  <app-basic-cartesian-chart
    [config]="ChartConfig.SurfacewaterH11"
    targetSiteName="ARL Hoteo"
    [enableExpansion]="true"
    class="hide-check"
  ></app-basic-cartesian-chart>
  <app-basic-cartesian-chart
    [config]="ChartConfig.ARLSurfaceWaterLevels"
    targetSiteName="ARL Hoteo"
    [enableExpansion]="true"
    class="hide-check"
  ></app-basic-cartesian-chart>
  <app-basic-cartesian-chart
    [config]="ChartConfig.SurfaceWaterConductivity"
    targetSiteName="ARL Hoteo"
    [enableExpansion]="true"
    class="hide-check"
  ></app-basic-cartesian-chart>
  <app-basic-cartesian-chart
    [config]="ChartConfig.SurfaceWaterTurbidity"
    targetSiteName="ARL Hoteo"
    [enableExpansion]="true"
    class="hide-check"
  ></app-basic-cartesian-chart>
  <app-basic-cartesian-chart
    [config]="ChartConfig.SurfaceWaterTemperature"
    targetSiteName="ARL Hoteo"
    [enableExpansion]="true"
    class="hide-check"
  ></app-basic-cartesian-chart>
  <app-basic-cartesian-chart
    [config]="ChartConfig.COD"
    targetSiteName="ARL Hoteo"
    [enableExpansion]="true"
    class="hide-check"
  ></app-basic-cartesian-chart>
  <app-basic-cartesian-chart
    [config]="ChartConfig.CDM"
    targetSiteName="ARL Hoteo"
    [enableExpansion]="true"
    class="hide-check"
  ></app-basic-cartesian-chart>
  <app-basic-cartesian-chart
    [config]="ChartConfig.Temperature"
    targetSiteName="ARL Hoteo"
    [enableExpansion]="true"
    class="hide-check"
  ></app-basic-cartesian-chart>
  <app-basic-cartesian-chart
    [config]="ChartConfig.pH"
    targetSiteName="ARL Hoteo"
    [enableExpansion]="true"
    class="hide-check"
  ></app-basic-cartesian-chart>
  <app-basic-cartesian-chart
    [config]="ChartConfig.Alkalinity"
    targetSiteName="ARL Hoteo"
    [enableExpansion]="true"
    class="hide-check"
  ></app-basic-cartesian-chart>
  <app-basic-cartesian-chart
    [config]="ChartConfig.Arsenic"
    targetSiteName="ARL Hoteo"
    [enableExpansion]="true"
    class="hide-check"
  ></app-basic-cartesian-chart>
  <app-basic-cartesian-chart
    [config]="ChartConfig.Copper"
    targetSiteName="ARL Hoteo"
    [enableExpansion]="true"
    class="hide-check"
  ></app-basic-cartesian-chart>
  <app-basic-cartesian-chart
    [config]="ChartConfig.Iron"
    targetSiteName="ARL Hoteo"
    [enableExpansion]="true"
    class="hide-check"
  ></app-basic-cartesian-chart>
  <app-basic-cartesian-chart
    [config]="ChartConfig.Lead"
    targetSiteName="ARL Hoteo"
    [enableExpansion]="true"
    class="hide-check"
  ></app-basic-cartesian-chart>
  <app-basic-cartesian-chart
    [config]="ChartConfig.Zinc"
    targetSiteName="ARL Hoteo"
    [enableExpansion]="true"
    class="hide-check"
  ></app-basic-cartesian-chart>
  <app-basic-cartesian-chart
    [config]="ChartConfig.Magnesium"
    targetSiteName="ARL Hoteo"
    [enableExpansion]="true"
    class="hide-check"
  ></app-basic-cartesian-chart>
  <app-basic-cartesian-chart
    [config]="ChartConfig.Manganese"
    targetSiteName="ARL Hoteo"
    [enableExpansion]="true"
    class="hide-check"
  ></app-basic-cartesian-chart>
  <app-basic-cartesian-chart
    [config]="ChartConfig.Nickel"
    targetSiteName="ARL Hoteo"
    [enableExpansion]="true"
    class="hide-check"
  ></app-basic-cartesian-chart>
  <app-basic-cartesian-chart
    [config]="ChartConfig.NitrateNitrogen"
    targetSiteName="ARL Hoteo"
    [enableExpansion]="true"
    class="hide-check"
  ></app-basic-cartesian-chart>
  <app-basic-cartesian-chart
    [config]="ChartConfig.Potassium"
    targetSiteName="ARL Hoteo"
    [enableExpansion]="true"
    class="hide-check"
  ></app-basic-cartesian-chart>
  <app-basic-cartesian-chart
    [config]="ChartConfig.Sodium"
    targetSiteName="ARL Hoteo"
    [enableExpansion]="true"
    class="hide-check"
  ></app-basic-cartesian-chart>
  <app-basic-cartesian-chart
    [config]="ChartConfig.Sulphate"
    targetSiteName="ARL Hoteo"
    [enableExpansion]="true"
    class="hide-check"
  ></app-basic-cartesian-chart>
  <app-basic-cartesian-chart
    [config]="ChartConfig.Boron"
    targetSiteName="ARL Hoteo"
    [enableExpansion]="true"
    class="hide-check"
  ></app-basic-cartesian-chart>
  <app-basic-cartesian-chart
    [config]="ChartConfig.Calcium"
    targetSiteName="ARL Hoteo"
    [enableExpansion]="true"
    class="hide-check"
  ></app-basic-cartesian-chart>
  <app-basic-cartesian-chart
    [config]="ChartConfig.Chloride"
    targetSiteName="ARL Hoteo"
    [enableExpansion]="true"
    class="hide-check"
  ></app-basic-cartesian-chart>
  <app-basic-cartesian-chart
    [config]="ChartConfig.TotalAmmoniacalNitrogen"
    targetSiteName="ARL Hoteo"
    [enableExpansion]="true"
    class="hide-check"
  ></app-basic-cartesian-chart>
  <app-basic-cartesian-chart
    [config]="ChartConfig.TotalHardness"
    targetSiteName="ARL Hoteo"
    [enableExpansion]="true"
    class="hide-check"
  ></app-basic-cartesian-chart>
  <app-basic-cartesian-chart
    [config]="ChartConfig.Bicarbonate"
    targetSiteName="ARL Hoteo"
    [enableExpansion]="true"
    class="hide-check"
  ></app-basic-cartesian-chart>
  <app-basic-cartesian-chart
    [config]="ChartConfig.SumOfAnions"
    targetSiteName="ARL Hoteo"
    [enableExpansion]="true"
    class="hide-check"
  ></app-basic-cartesian-chart>
  <app-basic-cartesian-chart
    [config]="ChartConfig.SumOfCations"
    targetSiteName="ARL Hoteo"
    [enableExpansion]="true"
    class="hide-check"
  ></app-basic-cartesian-chart>
</div>

<div class="dashboardPage" *ngIf="site?.name === 'Kate Valley Landfill'">
  <legacy-app-widget-overview title="Example of Landfill Performance Summary"></legacy-app-widget-overview>
  <app-widget-maramataka-phase *ngIf="domain === 'overview'"></app-widget-maramataka-phase>
  <app-widget-monitoring-information *ngIf="domain === 'overview'"></app-widget-monitoring-information>
  <legacy-app-widget-taiao-scorecard *ngIf="domain === 'overview'"></legacy-app-widget-taiao-scorecard>
  <div class="double-width">
    <legacy-app-widget-water-take *ngIf="domain === 'wai' || domain === 'overview'"></legacy-app-widget-water-take>
  </div>
  <legacy-app-widget-oxygen
    *ngIf="domain === 'moana' || domain === 'whenua' || domain === 'hau'"
  ></legacy-app-widget-oxygen>
  <app-basic-cartesian-chart
    *ngIf="domain === 'wai' || domain === 'overview'"
    [config]="ChartConfig.ARLGroundWaterLevels"
    targetSiteName="Kate Valley Landfill"
  ></app-basic-cartesian-chart>
  <legacy-app-widget-water-monitoring-ph
    *ngIf="domain === 'overview' || domain === 'wai'"
  ></legacy-app-widget-water-monitoring-ph>
  <legacy-app-widget-groundwater-wells
    *ngIf="domain === 'overview' || domain === 'wai'"
  ></legacy-app-widget-groundwater-wells>
  <legacy-app-widget-swa *ngIf="domain === 'overview' || domain === 'wai'"></legacy-app-widget-swa>
  <legacy-app-widget-swc *ngIf="domain === 'overview' || domain === 'wai'"></legacy-app-widget-swc>
  <legacy-app-widget-methane *ngIf="domain === 'overview'"></legacy-app-widget-methane>
  <legacy-app-widget-water-monitoring-conductivity
    *ngIf="domain === 'overview' || domain === 'wai'"
  ></legacy-app-widget-water-monitoring-conductivity>
  <legacy-app-widget-groundwater-protection
    *ngIf="domain === 'overview' || domain === 'wai'"
  ></legacy-app-widget-groundwater-protection>
  <legacy-app-widget-swb *ngIf="domain === 'overview' || domain === 'wai'"></legacy-app-widget-swb>
  <legacy-app-widget-swd *ngIf="domain === 'overview' || domain === 'wai'"></legacy-app-widget-swd>
  <app-weather-forecast-chart *ngIf="domain === 'overview'"></app-weather-forecast-chart>
  <legacy-app-widget-methane *ngIf="domain === 'overview'" [ngStyle]="{ opacity: 0 }"></legacy-app-widget-methane>
  <legacy-app-widget-indicators *ngIf="domain === 'wai'"></legacy-app-widget-indicators>
  <app-widget-kokopu *ngIf="domain === 'wai'"></app-widget-kokopu>
</div>
